import React from 'react';
import FaiBox from "../../../MuiComponents/FaiBox";
import DataTable from "../../../components/DataTable";
import FaiTypography from '../../../MuiComponents/FaiTypography';
import typography from '../../../assets/theme/base/typography';

interface ReportListProps {
    data: any;

    [key: string]: any;
}

function ReportList<ReportListProps>(props: { data: any; }) {
    const {data} = props;
    return (
        <>
        <FaiTypography variant={"h5"} fontWeight={typography.fontWeightMedium} mb={"21px"}>
            Report List
        </FaiTypography>
            <FaiBox>
                <DataTable
                    table={data}
                    pagination={{
                        variant: "contained",
                        color: "primary",
                    }}/>
            </FaiBox>
        </>
    );
}

export default ReportList;
